import {
  Button,
  JobStatusStyle,
  Close
} from "@/imports-files/components/common-modal/common-modal";
import { useTranslation } from "@/imports-files/common/common";

const JobStatusModal = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  return (
    <div className={`${JobStatusStyle.ModalOverlay}`}>
      <div className={`${JobStatusStyle.Modal} ${props?.filterWidth && JobStatusStyle.FilterModal} ${props?.jobFilterModal && `JobFilterModal`} ${props?.ScoreCardModal && JobStatusStyle.ScoreCardModal}`}  >
        <div className={`${JobStatusStyle.Modal__Container} ${props?.largeWidth && JobStatusStyle.ModalLarge} ${props?.NoOuterPadding && JobStatusStyle.NoOuterPadding} ${props?.kanbanFilterModal && `kanbanfitermodal`}`}>
          {/* Job board status */}
        <div className={`${JobStatusStyle.Modal__Container__CloseSection} text-right`} onClick={() => {props?.closeModal();}}><Close/></div>
         <div className={`${JobStatusStyle.Modal__Container__Section}`}>
          <div className={`${JobStatusStyle.Modal__Container__Heading__Close} ${props?.ScoreCardModal && JobStatusStyle.ScoreCardModal__Heading__Close}`}>
              <h1 className={`${JobStatusStyle.Modal__Container__ContentSection__Heading}`}>{t('job_board_status')}</h1>
          </div>
          <div className={JobStatusStyle.Modal__Container__ContentSection}>
            {props?.jobBoardContent}
          </div>

          {/* Job board status */}

        { props?.jobApprovalData.length > 0 && <>

          {/* Job approval status */}
          <div className={`${JobStatusStyle.Modal__Container__Heading__Close} ${props?.ScoreCardModal} mt30`}>
            <h1 className={`${JobStatusStyle.Modal__Container__ContentSection__Heading}`}>{t('job_approval_status')}</h1>
          </div>
          <table className="ApproverList">
                <tr>
                  <th>{t('modal:info:job:approver')}</th>
                  <th>{t('modal:info:job:status')}</th>
                  <th>{t('modal:info:job:date_and_time')}</th>
                </tr>
                {props?.jobApprovalData.map((element, index) => {
                  return (
                    <tr>
                      <td>
                        <div
                          key={`job_owner_initials_${index}`}
                          className="d-flex align-items-center w100"
                        >
                          {element?.photo_url ? (
                            <div className="JobInitial mr5">
                              <img
                                src={element?.photo_url}
                                className="JobImage"
                              />
                            </div>
                          ) : (
                            <div className="JobInitial mr5">
                              <span>
                                {element.name_initials
                                  ? element.name_initials
                                  : "?"}
                              </span>
                            </div>
                          )}
                          <span className="ApproverEmail">
                            {element.name || element.email}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span className="ApproverStatus">
                          {element.status}
                        </span>
                      </td>
                      <td>
                        <span className="ApproverStatus">
                          {element.date_and_time}
                        </span>
                      </td>
                    </tr>
                  );
                })}
          </table>
          </>  
        }
          {/* Job approval status */}
        </div>
        </div>
      </div>
    </div>
  );
};
export default JobStatusModal;
